<template>
  <div class="row account-edit">
    <div class="col ">
      <InformationProfile />
      <Games />
      <Platforms />
      <div class="row column-smaller-screen">
        <div class="col ">
          <Streaming :columns="1" />
        </div>
        <div class="col ">
          <Socials :columns="1" />
        </div>
      </div>
      <RemoveAccount />
    </div>
  </div>
</template>

<script>
import InformationProfile from './panels/InformationProfile';
import Games from './panels/Games';

import Socials from './panels/Socials';
import Streaming from './panels/Streaming';
import Platforms from './panels/Platforms';
import RemoveAccount from './panels/RemoveAccount';

export default {
  name: 'AccountEditProfile',
  components: {
    InformationProfile,
    Games,
    Socials,
    Streaming,
    Platforms,
    RemoveAccount,
  },
};
</script>
<style lang="scss">
.account-edit {
  margin-top: 24px;
  .input-form {
    background-color: #1c212b !important;
  }
  .mx-input {
    background-color: #1c212b !important;
    max-width: none;
  }
}
@media (max-width: 767px) {
  .account-edit {
    margin-top: 24px;
  }

  .column-smaller-screen {
    flex-direction: column !important;
  }
}
</style>
